"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportTable = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
// 표 내부 로딩 스피너 애니메이션(전체화면 로딩 대신 이 표 정중앙에 표시)
const reportSpin = (0, styled_components_1.keyframes) `
	0% { transform: rotate(0deg); }
	100% { transform: rotate(360deg); }
`;
const ReportTableStyled = styled_components_1.default.div `
	width: 100%;
	/* 표 내부 로딩 오버레이의 기준 컨테이너 */
	position: relative;

	/* 검색/필터 로딩 — 이 표의 정중앙에 스피너 표시(전체화면 로딩 대체) */
	.report-loading-overlay {
		position: absolute;
		inset: 0;
		z-index: 5;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(255, 255, 255, 0.6);
		/* 순수 시각 표시 — 로딩 중에도 조작 가능 */
		pointer-events: none;
	}

	.report-loading-spinner {
		width: 36px;
		height: 36px;
		border: 4px solid var(--color-silver, #e6e8ed);
		border-top-color: var(--tur-d, #479da6);
		border-radius: 50%;
		animation: ${reportSpin} 0.8s linear infinite;
	}

	.report-list-001,
	.section-table {
		display: flex;
		flex-direction: column;
		align-self: stretch;
	}

	.report-list-001 .table-header,
	.section-table .table-header {
		background: #f3f4f8;
		border-style: solid;
		border-color: #b6bac0;
		border-width: 1px 0 0 0;
		display: flex;
		align-items: center;
	}

	.report-list-001 .table-header {
		padding: 10px 16px;
		gap: 20px;
	}

	.section-table .table-header {
		padding: 10px 12px;
		gap: 16px;
	}

	.report-list-001 .table-header .table-header-item,
	.section-table .table-header .table-header-item {
		justify-content: center;
		text-align: center;
	}

	.report-list-001 .table-header .head-class_name,
	.report-list-001 .table-header .head-test_name,
	.report-list-001 .table-header .head-assignment_name,
	.report-list-001 .table-header .head-name,
	.section-table .table-header .head-class_name,
	.section-table .table-header .head-test_name,
	.section-table .table-header .head-assignment_name {
		justify-content: flex-start;
		text-align: left;
	}

	.report-list-001 .table-header .head-class_name p,
	.report-list-001 .table-header .head-test_name p,
	.report-list-001 .table-header .head-assignment_name p,
	.report-list-001 .table-header .head-name p,
	.section-table .table-header .head-class_name p,
	.section-table .table-header .head-test_name p,
	.section-table .table-header .head-assignment_name p {
		text-align: left;
	}

	.report-list-001 .table-header p,
	.report-list-001 .item span {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile }) => ($isMobile ? '12px' : '14px')};
		line-height: 150%;
		letter-spacing: -0.02em;
	}

	.section-table .table-header p,
	.section-table .item span {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile }) => ($isMobile ? '12px' : '13px')};
		line-height: 150%;
		letter-spacing: -0.02em;
	}

	.report-list-001 .item,
	.section-table .item {
		display: flex;
		align-items: center;
		border-bottom: 1px solid #eceef2;
	}

	.report-list-001 .item {
		padding: 10px 16px;
		gap: 20px;
	}

	.section-table .item {
		padding: 10px 12px;
		gap: 16px;
	}

	.report-list-001 .table-item-wrap,
	.section-table .table-item-wrap {
		height: auto;
	}

	.student-status-chip-wrap {
		width: 50px;
		display: inline-flex;
		justify-content: flex-start;
		flex-shrink: 0;
	}

	.student-status-chip {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 2px 8px;
		border-radius: 6px;
		border: 1px solid #b6bac0;
		background: #fff;
		color: #101010;
		font-size: 12px;
		font-weight: 700;
		line-height: 150%;
		white-space: nowrap;
	}

	.student-status-chip.late {
		background: #f3efc7;
		border-color: #e2dc96;
	}

	.student-status-chip.absent,
	.student-status-chip.not-submit {
		background: #eceef2;
		border-color: #e0e3e8;
	}

	.mobile-report-item {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.report-list-001 .table-item-wrap .mobile_item.item,
	.section-table .table-item-wrap .mobile_item.item {
		display: block;
		padding: 16px 0;
		border-bottom: 1px solid #e4e6ea;
		background: transparent;
	}

	.report-list-001 .table-item-wrap .mobile_item.item:last-child,
	.section-table .table-item-wrap .mobile_item.item:last-child {
		border-bottom: none;
	}

	.mobile-card-header {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.mobile-card-name {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 1.2;
		font-weight: 700;
		display: flex;
		align-items: center;
		min-height: 24px;
	}

	.mobile-card-subject {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 12px;
		line-height: 120%;
	}

	.mobile-card-meta {
		color: #7b7d84;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 12px;
		line-height: 120%;
	}

	.mobile-card-action {
		height: 30px;
		border: none;
		border-radius: 9px;
		background: #6f6f70;
		color: #fff;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 12px;
	}

	.mobile-overview-topline {
		display: flex;
		align-items: center;
		gap: 10px;
		flex-wrap: wrap;
	}

	.mobile-chip {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 7px;
		border: 1px solid #d7d9dc;
		padding: 2px 10px;
		font-size: 14px;
	}

	.mobile-title {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 1.2;
		font-weight: 700;
	}

	.mobile-meta {
		color: #7b7d84;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 12px;
		line-height: 1.2;
	}

	.mobile-subject {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 12px;
		line-height: 1.2;
	}
`;
const statusLabelMap = {
    attend: '출석',
    late: '지각',
    absent: '결석',
    submit: '응시',
    'not-submit': '미응시',
};
const getStatusClassName = (status) => status;
const getAttendanceMetaText = (row) => {
    const parts = [row.date];
    if (row.durationMinutes !== null) {
        parts.push(`참여 ${row.durationMinutes}분`);
    }
    parts.push(row.enrolledStatus);
    return parts.join('  ·  ');
};
const getExamMetaText = (row) => {
    const parts = [row.date];
    if (row.score !== null) {
        parts.push(`점수 ${row.score}점`);
    }
    parts.push(row.enrolledStatus);
    return parts.join('  ·  ');
};
const buildWeeklyHeadTitles = (segment) => segment === 'attendance'
    ? [
        { title: 'date', space: 1 },
        { title: 'class_name', space: 2.8 },
        { title: 'name', space: 1 },
        { title: 'student_id', space: 1 },
        { title: 'attendanceStatus', space: 1 },
        { title: 'participantTime', space: 1 },
        { title: 'enrolled_status', space: 1 },
    ]
    : [
        { title: 'date', space: 1 },
        { title: segment === 'test' ? 'test_name' : 'assignment_name', space: 2.8 },
        { title: 'name', space: 1 },
        { title: 'student_id', space: 1 },
        { title: 'submit_status', space: 1 },
        { title: 'score', space: 1 },
        { title: 'enrolled_status', space: 1 },
    ];
// ── 선택과목 동적 컬럼 ──
// 클래스의 실제 선택과목을 개별 컬럼으로 노출(예: 수학 클래스 → 기하/미적분/확률과 통계).
// 컬럼 목록은 "기본형(OMR)만 집계하는" 선택과목 응시분포 API(total/tests/optional)의 키에서
// 유도한다(서버 2026-07-29 변경). ★행(total/tests)의 done_by_optional 합집합으로 유도 금지 —
// total/tests 는 자유형(OMR-free)도 포함해 임의 선택과목이 컬럼으로 샌다(서버 확인 사고).
// 표준 과목군은 한 과목이라도 등장하면 세트 전체를 완성해 응시자 0명 과목도 컬럼으로 보인다
// (정렬은 수능 표기 순). 그 외 키(탐구 등 서버 신규 과목)는 등장 순서대로 뒤에 붙는다 —
// 하드코딩 고정 컬럼 금지(과목 무관하게 미적분/확통이 떴던 실사고의 재발 방지).
const SUBJECT_GROUPS = [
    ['화법과 작문', '언어와 매체'],
    ['확률과 통계', '미적분', '기하'],
];
const OPTIONAL_COL_PREFIX = 'optional__';
const buildOptionalColumns = (subjects) => {
    const seen = [];
    const seenSet = new Set();
    subjects.forEach(name => {
        if (name && !seenSet.has(name)) {
            seenSet.add(name);
            seen.push(name);
        }
    });
    if (!seen.length)
        return [];
    const columns = [];
    SUBJECT_GROUPS.forEach(group => {
        if (group.some(name => seenSet.has(name))) {
            group.forEach(name => {
                columns.push(name);
                seenSet.delete(name);
            });
        }
    });
    seen.forEach(name => {
        if (seenSet.has(name))
            columns.push(name);
    });
    return columns;
};
const buildOverallHeadTitles = (segment, optionalColumns = []) => segment === 'attendance'
    ? [
        { title: 'weeks', space: 0.8 },
        { title: 'date', space: 1 },
        { title: 'class_name', space: 2.8 },
        { title: 'target_count', space: 0.9 },
        { title: 'attend_count', space: 0.8 },
        { title: 'late_count', space: 0.8 },
        { title: 'absent_count', space: 0.8 },
        { title: 'attendance_rate', space: 0.8 },
    ]
    : [
        { title: 'weeks', space: 0.8 },
        { title: 'date', space: 1 },
        { title: segment === 'test' ? 'test_name' : 'assignment_name', space: 2.8 },
        { title: 'submit_target_count', space: 0.9 },
        { title: 'submit_count', space: 0.8 },
        // 선택과목 컬럼은 데이터에서 유도(위 buildOptionalColumns) — label 로 raw 과목명 표기
        ...optionalColumns.map(name => ({ title: `${OPTIONAL_COL_PREFIX}${name}`, label: name, space: 0.9 })),
        { title: 'not_submit_count', space: 0.8 },
        { title: 'submit_rate', space: 0.8 },
    ];
exports.ReportTable = react_1.default.memo(({ variant, segment, data, renderEmpty, onScoreClick, loading = false, optionalSubjects, }) => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    // data(필터 결과)가 바뀔 때마다 ReportTable 전체가 리렌더되는데, 아래 render* 함수들을
    // 매번 새로 만들면 그 새 함수 참조가 renderItem → Table → TableItem 까지 흘러가
    // TableItem 내부 useMemo(참조 비교)가 매번 깨져 검색과 무관한 행까지 전부 재생성된다.
    // segment/variant/onScoreClick 이 그대로인 한 참조가 유지되도록 useCallback/useMemo 로 고정.
    // 전체 현황 테스트/과제의 선택과목 동적 컬럼 — 기본형만 집계하는 분포 API 키에서 유도
    // (행 합집합 유도 금지: 자유형 테스트의 done_by_optional 과목이 컬럼으로 샌다).
    // 빈 배열이면 미노출.
    const optionalColumns = react_1.default.useMemo(() => variant === 'overall' && segment !== 'attendance'
        ? buildOptionalColumns(optionalSubjects || [])
        : [], [variant, segment, optionalSubjects]);
    const headTitleList = react_1.default.useMemo(() => (variant === 'weekly' ? buildWeeklyHeadTitles(segment) : buildOverallHeadTitles(segment, optionalColumns)), [variant, segment, optionalColumns]);
    const renderWeeklyMobileItem = react_1.default.useCallback((row) => {
        if (segment === 'attendance') {
            const attendanceRow = row;
            return (react_1.default.createElement("div", { className: "mobile-report-item" },
                react_1.default.createElement("div", { className: "mobile-card-header" },
                    react_1.default.createElement("div", { className: "student-status-chip-wrap" },
                        react_1.default.createElement("span", { className: `student-status-chip ${getStatusClassName(attendanceRow.status)}` }, statusLabelMap[attendanceRow.status])),
                    react_1.default.createElement("div", { className: "mobile-card-name" }, `${attendanceRow.studentName} (${attendanceRow.studentId})`)),
                react_1.default.createElement("div", { className: "mobile-card-subject" }, attendanceRow.className),
                react_1.default.createElement("div", { className: "mobile-card-meta" }, getAttendanceMetaText(attendanceRow))));
        }
        const examRow = row;
        return (react_1.default.createElement("div", { className: "mobile-report-item" },
            react_1.default.createElement("div", { className: "mobile-card-header" },
                react_1.default.createElement("div", { className: "student-status-chip-wrap" },
                    react_1.default.createElement("span", { className: `student-status-chip ${getStatusClassName(examRow.status)}` }, statusLabelMap[examRow.status])),
                react_1.default.createElement("div", { className: "mobile-card-name" }, `${examRow.studentName} (${examRow.studentId})`)),
            react_1.default.createElement("div", { className: "mobile-card-subject" }, examRow.title),
            react_1.default.createElement("div", { className: "mobile-card-meta" }, getExamMetaText(examRow)),
            segment === 'test' && examRow.score !== null && (react_1.default.createElement("button", { type: "button", className: "mobile-card-action", onClick: () => onScoreClick?.(examRow, 'test') }, "\uC131\uC801\uD45C \uBCF4\uAE30"))));
    }, [segment, onScoreClick]);
    const renderOverallMobileItem = react_1.default.useCallback((row) => (react_1.default.createElement("div", { className: "mobile-report-item" },
        react_1.default.createElement("div", { className: "mobile-overview-topline" },
            react_1.default.createElement("span", { className: "mobile-chip" }, row.weekLabel),
            react_1.default.createElement("div", { className: "mobile-title" }, 'title' in row ? row.title : row.className)),
        react_1.default.createElement("div", { className: "mobile-title" }, `${segment === 'attendance' ? '출석률' : '응시율'} ${row.rate}%`),
        react_1.default.createElement("div", { className: "mobile-meta" }, row.date),
        react_1.default.createElement("div", { className: "mobile-meta" }, segment === 'attendance'
            ? `대상 ${row.targetCount}명  ·  출석 ${row.attendCount}명  ·  지각 ${row.lateCount}명  ·  결석 ${row.absentCount}명`
            : `대상 ${row.targetCount}명  ·  응시 ${row.submitCount}명  ·  미응시 ${row.notSubmitCount}명`),
        segment !== 'attendance' && optionalColumns.length > 0 && (react_1.default.createElement("div", { className: "mobile-subject" }, `선택과목  ${optionalColumns
            .map(name => `${name} ${row.subjectCounts?.[name] ?? 0}명`)
            .join('  ·  ')}`)))), [segment, optionalColumns]);
    const renderWeeklyDesktopRow = react_1.default.useCallback((row, styles) => {
        const rowKeys = segment === 'attendance'
            ? ['date', 'class_name', 'name', 'student_id', 'attendanceStatus', 'participantTime', 'enrolled_status']
            : ['date', 'title', 'name', 'student_id', 'submit_status', 'score', 'enrolled_status'];
        return rowKeys.map((key, keyIndex) => {
            const commonStyle = {
                flex: headTitleList[keyIndex].space,
                ...styles?.bodyItem,
                overflow: 'hidden',
            };
            if (segment === 'attendance') {
                const attendanceRow = row;
                switch (key) {
                    case 'date':
                        return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                            react_1.default.createElement("span", null, attendanceRow.date));
                    case 'class_name':
                        return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'flex-start' } },
                            react_1.default.createElement("span", { className: "overText2" }, attendanceRow.className));
                    case 'name':
                        return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'flex-start' } },
                            react_1.default.createElement("span", { className: "overText2" }, attendanceRow.studentName));
                    case 'student_id':
                        return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                            react_1.default.createElement("span", null, attendanceRow.studentId));
                    case 'attendanceStatus':
                        return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                            react_1.default.createElement("div", { className: "student-status-chip-wrap" },
                                react_1.default.createElement("span", { className: `student-status-chip ${getStatusClassName(attendanceRow.status)}` }, statusLabelMap[attendanceRow.status])));
                    case 'participantTime':
                        return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                            react_1.default.createElement("span", null, attendanceRow.durationMinutes !== null ? `${attendanceRow.durationMinutes}분` : '-'));
                    case 'enrolled_status':
                        return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                            react_1.default.createElement("span", null, attendanceRow.enrolledStatus));
                    default:
                        return null;
                }
            }
            const examRow = row;
            switch (key) {
                case 'date':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", null, examRow.date));
                case 'title':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'flex-start' } },
                        react_1.default.createElement("span", { className: "overText2" }, examRow.title));
                case 'name':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'flex-start' } },
                        react_1.default.createElement("span", { className: "overText2" }, examRow.studentName));
                case 'student_id':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", null, examRow.studentId));
                case 'submit_status':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("div", { className: "student-status-chip-wrap" },
                            react_1.default.createElement("span", { className: `student-status-chip ${getStatusClassName(examRow.status)}` }, statusLabelMap[examRow.status])));
                case 'score':
                    return (react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", { style: {
                                textDecoration: examRow.score !== null ? 'underline' : 'none',
                                cursor: examRow.score !== null ? 'pointer' : 'default',
                            }, onClick: examRow.score !== null ? () => onScoreClick?.(examRow, segment) : undefined, role: examRow.score !== null ? 'button' : undefined, tabIndex: examRow.score !== null ? 0 : undefined, onKeyDown: examRow.score !== null
                                ? event => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        event.preventDefault();
                                        onScoreClick?.(examRow, segment);
                                    }
                                }
                                : undefined }, examRow.score ?? '-')));
                case 'enrolled_status':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", null, examRow.enrolledStatus));
                default:
                    return null;
            }
        });
    }, [segment, headTitleList, onScoreClick]);
    const renderOverallDesktopRow = react_1.default.useCallback((row, styles) => {
        const rowKeys = segment === 'attendance'
            ? ['weeks', 'date', 'class_name', 'target_count', 'attend_count', 'late_count', 'absent_count', 'attendance_rate']
            : [
                'weeks',
                'date',
                segment === 'test' ? 'test_name' : 'assignment_name',
                'submit_target_count',
                'submit_count',
                // 헤더(buildOverallHeadTitles)와 인덱스 정렬이 유지되도록 동일 순서로 삽입
                ...optionalColumns.map(name => `${OPTIONAL_COL_PREFIX}${name}`),
                'not_submit_count',
                'submit_rate',
            ];
        return rowKeys.map((key, keyIndex) => {
            const commonStyle = {
                flex: headTitleList[keyIndex].space,
                ...styles?.bodyItem,
                overflow: 'hidden',
            };
            // 선택과목 동적 컬럼 — 해당 행(테스트)에 없는 과목은 0명
            if (key.startsWith(OPTIONAL_COL_PREFIX)) {
                const name = key.slice(OPTIONAL_COL_PREFIX.length);
                const count = row.subjectCounts?.[name] ?? 0;
                return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                    react_1.default.createElement("span", null,
                        count,
                        "\uBA85"));
            }
            switch (key) {
                case 'weeks':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", null, row.weekLabel));
                case 'date':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", null, row.date));
                case 'class_name':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'flex-start' } },
                        react_1.default.createElement("span", { className: "overText2" }, row.className));
                case 'test_name':
                case 'assignment_name':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'flex-start' } },
                        react_1.default.createElement("span", { className: "overText2" }, row.title));
                case 'submit_target_count':
                case 'target_count':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", null,
                            row.targetCount,
                            "\uBA85"));
                case 'attend_count':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", null,
                            row.attendCount,
                            "\uBA85"));
                case 'late_count':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", null,
                            row.lateCount,
                            "\uBA85"));
                case 'absent_count':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", null,
                            row.absentCount,
                            "\uBA85"));
                case 'submit_count':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", null,
                            row.submitCount,
                            "\uBA85"));
                case 'not_submit_count':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", null,
                            row.notSubmitCount,
                            "\uBA85"));
                case 'attendance_rate':
                case 'submit_rate':
                    return react_1.default.createElement("div", { key: `${row.id}-${key}`, style: { ...commonStyle, display: 'flex', justifyContent: 'center' } },
                        react_1.default.createElement("span", null,
                            row.rate,
                            "%"));
                default:
                    return null;
            }
        });
    }, [segment, headTitleList, optionalColumns]);
    const renderItem = react_1.default.useCallback((item, styles, index, isMobileView) => {
        if (isMobileView) {
            return variant === 'weekly'
                ? renderWeeklyMobileItem(item)
                : renderOverallMobileItem(item);
        }
        return variant === 'weekly'
            ? renderWeeklyDesktopRow(item, styles)
            : renderOverallDesktopRow(item, styles);
    }, [variant, renderWeeklyMobileItem, renderOverallMobileItem, renderWeeklyDesktopRow, renderOverallDesktopRow]);
    return (react_1.default.createElement(ReportTableStyled, { "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": isDesktop },
        loading && (react_1.default.createElement("div", { className: "report-loading-overlay", "aria-live": "polite", "aria-busy": "true" },
            react_1.default.createElement("div", { className: "report-loading-spinner" }))),
        react_1.default.createElement(common_1.Table, { className: variant === 'weekly' ? 'report-list-001' : 'section-table', headTitleList: headTitleList, isInfinite: true, data: data, padding: false, page: 0, totalCount: data.length, forceShowheader: !isMobile, renderEmpty: data.length === 0 ? renderEmpty : undefined, renderItem: renderItem })));
});
exports.default = exports.ReportTable;
